import { useState } from 'react'
import Certificates from './Certificates'
import Projects from './Projects'
import SocialProfiles from './SocialProfiles'
import { IoIosClose } from "react-icons/io";

export default function Highlights({ candidate, currentUser }) {

    const [viewData, setViewData] = useState(null)
    const [popupTitle, setPopupTitle] = useState("")

    const resetPopupData = () => {
        setViewData(null)
        setPopupTitle("")
    }


    const formatValue = (val) => {
        if (val === true) return "Yes"
        if (val === false) return "No"
        // try date
        const maybeDate = new Date(val)
        if (val && !Number.isNaN(maybeDate.getTime())) return maybeDate.toLocaleDateString()
        return val
    }

    return (
        <div className='relative lg:flex lg:flex-wrap gap-3 justify-center w-full '>
            <Certificates candidate={candidate} setViewData={setViewData} setPopupTitle={setPopupTitle} currentUser={currentUser} />
            <Projects candidate={candidate} setViewData={setViewData} setPopupTitle={setPopupTitle} currentUser={currentUser} />
            <SocialProfiles candidate={candidate} setViewData={setViewData} setPopupTitle={setPopupTitle} currentUser={currentUser} />

            {
                (viewData && popupTitle) &&
                <div
                    className="fixed inset-0 z-40 flex items-center justify-center p-4"
                    role="dialog"
                    aria-modal="true"
                    aria-label={popupTitle}
                >
                    {/* backdrop */}
                    <div className="absolute inset-0 bg-black/40" onClick={resetPopupData} />

                    {/* panel */}
                    <div className="relative z-50 w-full max-w-2xl bg-white rounded-xl shadow-xl overflow-hidden">
                        {/* header */}
                        <div className="flex items-start justify-between p-2 border-b">
                            <div>
                                <h4 className="text-lg font-semibold">{popupTitle}</h4>
                            </div>
                            <button
                                onClick={resetPopupData}
                                aria-label="Close"
                                className="rounded-full p-2 hover:bg-slate-100 focus:outline-none"
                            >
                                <IoIosClose className="h-6 w-6 text-slate-700" />
                            </button>
                        </div>

                        {/* content */}
                        <div className="p-4 max-h-[60vh] overflow-auto">
                            <dl className="grid grid-cols-1 gap-2">
                                {
                                    Object.entries(viewData)
                                        .filter(([_, v]) => v !== null && v !== undefined && v !== "")
                                        .map(([key, value]) => (
                                            <div key={key} className="flex flex-col sm:flex-row sm:items-start sm:gap-2">
                                                <dt className="w-full sm:w-40 text-xs text-slate-400">{key}</dt>
                                                <dd className="mt-1 text-sm text-slate-800">{formatValue(value)}</dd>
                                            </div>
                                        ))
                                }
                            </dl>
                        </div>

                        {/* footer */}
                        <div className="p-2 border-t flex items-center justify-center">
                            <button
                                onClick={resetPopupData}
                                className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-indigo-600 text-white font-medium hover:brightness-95 focus:outline-none"
                            >
                                <IoIosClose className="h-4 w-4" />
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
